import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface ITVRCVRFormMeta {
    // Terminal verification results section information [0-22]
    offlineAuthenticationPerformed: FormInputMeta;
    servicePermittedByCardProduct: FormInputMeta;
    forcedOnlinMerchantTransaction: FormInputMeta;
    authenticationStaticDataPerformed: FormInputMeta;
    newCard: FormInputMeta;
    issuerAuthenticationFailure: FormInputMeta;
    presentChipData: FormInputMeta;
    carrierVerificationPerformed: FormInputMeta;
    exceedingTransactionLimit: FormInputMeta;
    panOrTerminalExceptionFile: FormInputMeta;
    unknownCvmOrOther: FormInputMeta;
    offlineMinimumLimitExceeded: FormInputMeta;
    differentTerminalAndChipVersions: FormInputMeta;
    outdatedTrialPin: FormInputMeta;
    offlineMaximumLimitExceed: FormInputMeta;
    applicationExpi: FormInputMeta;
    onlinePinEntered: FormInputMeta;
    randomlySelectedTransactionForOnline: FormInputMeta;
    activeApplication: FormInputMeta;
    pinInputRequired_PadPinNotWorking_Present: FormInputMeta;
    failedScriptProcessingBeforeFinalCryptogramGeneration: FormInputMeta;
    enteredPin_MandatoryNotEntered_PadPinPresent: FormInputMeta;
    failedScriptProcessingAfterFinalCryptogramGeneration: FormInputMeta;

    // Card Verification Results [23-38]
    issuerAuthenticationPerformedOnLastTransaction: FormInputMeta;
    impossibleOnline: FormInputMeta;
    issuerAuthenticationFailureOnLastTransaction: FormInputMeta;
    sda: FormInputMeta;
    scriptFailureTransmitterProcessing: FormInputMeta;
    lastOnlineTransactionNotCompleted: FormInputMeta;
    issuerAuthenticationFailure2: FormInputMeta;
    limitTrialPinExceeded: FormInputMeta;
    offlinePinVerificationPerformed: FormInputMeta;
    velocityCheckCountersExceeded: FormInputMeta;
    offlinePinVerificationFailure: FormInputMeta;
    newCard2: FormInputMeta;
    trialPinLimitAndApplicationBlocked: FormInputMeta;
      // Card Verification Results Text Input Fields [36-38]
    secondCryptogramType: FormInputMeta;
    firstCryptogramType: FormInputMeta;
    trialPinLimitExceededAndApplicationBlocked: FormInputMeta;

    schema: any;
}

const tvrCVRFormMeta = {} as ITVRCVRFormMeta;

// Terminal verification results section information
tvrCVRFormMeta.offlineAuthenticationPerformed = {
  name: "offlineAuthenticationPerformed",
  type: "checkbox",
  label: "Authentification Offline Effectuée",
  placeholder: "",
  validation: yup.boolean().required("Champ obligatoire !")
};

tvrCVRFormMeta.servicePermittedByCardProduct = {
  name: "servicePermittedByCardProduct",
  type: "checkbox",
  label: "Service Permis par Produit Carte",
  placeholder: "",
  validation: yup.boolean().required("Champ obligatoire !")
};

tvrCVRFormMeta.forcedOnlinMerchantTransaction = {
  name: "forcedOnlinMerchantTransaction",
  type: "checkbox",
  label: "Transaction Commerçant Online Forcée",
  placeholder: "",
  validation: yup.boolean().required("Champ obligatoire !")
};

tvrCVRFormMeta.authenticationStaticDataPerformed = {
  name: "authenticationStaticDataPerformed",
  type: "checkbox",
  label: "Authentification Donnée Statique Effectuée",
  placeholder: "",
  validation: yup.boolean().required("Champ obligatoire !")
};

tvrCVRFormMeta.newCard = {
  name: "newCard",
  type: "checkbox",
  label: "Nouvelle Carte",
  placeholder: "",
  validation: yup.boolean().required("Champ obligatoire !")
};

tvrCVRFormMeta.issuerAuthenticationFailure = {
  name: "issuerAuthenticationFailure",
  type: "checkbox",
  label: "Echec Authentification Emetteur",
  placeholder: "",
  validation: yup.boolean().required("Champ obligatoire !")
};

tvrCVRFormMeta.presentChipData = {
  name: "presentChipData",
  type: "checkbox",
  label: "Donnée Puce Présente",
  placeholder: "",
  validation: yup.boolean().required("Champ obligatoire !")
};

tvrCVRFormMeta.carrierVerificationPerformed = {
  name: "carrierVerificationPerformed",
  type: "checkbox",
  label: "Vérification Porteur Effectuée",
  placeholder: "",
  validation: yup.boolean().required("Champ obligatoire !")
};

tvrCVRFormMeta.exceedingTransactionLimit = {
  name: "exceedingTransactionLimit",
  type: "checkbox",
  label: "Dépass. Plafond Transaction",
  placeholder: "",
  validation: yup.boolean().required("Champ obligatoire !")
};

tvrCVRFormMeta.panOrTerminalExceptionFile = {
  name: "panOrTerminalExceptionFile",
  type: "checkbox",
  label: "Fichier Exception Pan ou Terminal",
  placeholder: "",
  validation: yup.boolean().required("Champ obligatoire !")
};

tvrCVRFormMeta.unknownCvmOrOther = {
  name: "unknownCvmOrOther",
  type: "checkbox",
  label: "CVM Inconnu ou Autre",
  placeholder: "",
  validation: yup.boolean().required("Champ obligatoire !")
};

tvrCVRFormMeta.offlineMinimumLimitExceeded = {
  name: "offlineMinimumLimitExceeded",
  type: "checkbox",
  label: "Limite Minimale Offline Dépassée",
  placeholder: "",
  validation: yup.boolean().required("Champ obligatoire !")
};

tvrCVRFormMeta.differentTerminalAndChipVersions = {
  name: "differentTerminalAndChipVersions",
  type: "checkbox",
  label: "Différentes Versions Terminal et Puce",
  placeholder: "",
  validation: yup.boolean().required("Champ obligatoire !")
};

tvrCVRFormMeta.outdatedTrialPin = {
  name: "outdatedTrialPin",
  type: "checkbox",
  label: "Essai Pin Dépassé",
  placeholder: "",
  validation: yup.boolean().required("Champ obligatoire !")
};

tvrCVRFormMeta.offlineMaximumLimitExceed = {
  name: "offlineMaximumLimitExceed",
  type: "checkbox",
  label: "Limite Maximale Offline Dépassé",
  placeholder: "",
  validation: yup.boolean().required("Champ obligatoire !")
};

tvrCVRFormMeta.applicationExpi = {
  name: "applicationExpi",
  type: "checkbox",
  label: "Application Expi.",
  placeholder: "",
  validation: yup.boolean().required("Champ obligatoire !")
};

tvrCVRFormMeta.onlinePinEntered = {
  name: "onlinePinEntered",
  type: "checkbox",
  label: "Pin Online Entré",
  placeholder: "",
  validation: yup.boolean().required("Champ obligatoire !")
};

tvrCVRFormMeta.randomlySelectedTransactionForOnline = {
  name: "randomlySelectedTransactionForOnline",
  type: "checkbox",
  label: "Transaction Sélectionnée Aléatoirement pour l'Online",
  placeholder: "",
  validation: yup.boolean().required("Champ obligatoire !")
};

tvrCVRFormMeta.activeApplication = {
  name: "activeApplication",
  type: "checkbox",
  label: "Active Application",
  placeholder: "",
  validation: yup.boolean().required("Champ obligatoire !")
};

tvrCVRFormMeta.pinInputRequired_PadPinNotWorking_Present = {
  name: "pinInputRequired_PadPinNotWorking_Present",
  type: "checkbox",
  label: "Pin Entré Obligatoire, Pad Pin ne fonctionne pas, Présent",
  placeholder: "",
  validation: yup.boolean().required("Champ obligatoire !")
};

tvrCVRFormMeta.failedScriptProcessingBeforeFinalCryptogramGeneration = {
  name: "failedScriptProcessingBeforeFinalCryptogramGeneration",
  type: "checkbox",
  label: "Echec Traitement Script Avant Génération Cryptogram Final",
  placeholder: "",
  validation: yup.boolean().required("Champ obligatoire !")
};

tvrCVRFormMeta.enteredPin_MandatoryNotEntered_PadPinPresent = {
  name: "enteredPin_MandatoryNotEntered_PadPinPresent",
  type: "checkbox",
  label: "Pin entré, Obligatoire non entré, Pad Pin Présent",
  placeholder: "",
  validation: yup.boolean().required("Champ obligatoire !")
};

tvrCVRFormMeta.failedScriptProcessingAfterFinalCryptogramGeneration = {
  name: "failedScriptProcessingAfterFinalCryptogramGeneration",
  type: "checkbox",
  label: "Echec Traitement Script Après Génération Cryptogram Final",
  placeholder: "",
  validation: yup.boolean().required("Champ obligatoire !")
};

// Card Verification Results section information
tvrCVRFormMeta.issuerAuthenticationPerformedOnLastTransaction = {
  name: "issuerAuthenticationPerformedOnLastTransaction",
  type: "checkbox",
  label: "Authentification Emetteur Exécutée lors de la Dernière Transaction",
  placeholder: "",
  validation: yup.boolean().required("Champ obligatoire !")
};

tvrCVRFormMeta.impossibleOnline = {
  name: "impossibleOnline",
  type: "checkbox",
  label: "Online Impossible",
  placeholder: "",
  validation: yup.boolean().required("Champ obligatoire !")
};

tvrCVRFormMeta.issuerAuthenticationFailureOnLastTransaction = {
  name: "issuerAuthenticationFailureOnLastTransaction",
  type: "checkbox",
  label: "Echec Authentification Emetteur lors de la Dernière Transaction",
  placeholder: "",
  validation: yup.boolean().required("Champ obligatoire !")
};

tvrCVRFormMeta.sda = {
  name: "sda",
  type: "checkbox",
  label: "SDA",
  placeholder: "",
  validation: yup.boolean().required("Champ obligatoire !")
};

tvrCVRFormMeta.scriptFailureTransmitterProcessing = {
  name: "scriptFailureTransmitterProcessing",
  type: "checkbox",
  label: "Echec du Script Traitement Emetteur",
  placeholder: "",
  validation: yup.boolean().required("Champ obligatoire !")
};

tvrCVRFormMeta.lastOnlineTransactionNotCompleted = {
  name: "lastOnlineTransactionNotCompleted",
  type: "checkbox",
  label: "Dernière Transaction Online Incomplète",
  placeholder: "",
  validation: yup.boolean().required("Champ obligatoire !")
};

tvrCVRFormMeta.issuerAuthenticationFailure2 = {
  ...tvrCVRFormMeta.issuerAuthenticationFailure,
  name: "issuerAuthenticationFailure2",
};

tvrCVRFormMeta.limitTrialPinExceeded = {
  name: "limitTrialPinExceeded",
  type: "checkbox",
  label: "Limite Essai Pin Dépassé",
  placeholder: "",
  validation: yup.boolean().required("Champ obligatoire !")
};

tvrCVRFormMeta.offlinePinVerificationPerformed = {
  name: "offlinePinVerificationPerformed",
  type: "checkbox",
  label: "Vérification Pin Offline Exécutée",
  placeholder: "",
  validation: yup.boolean().required("Champ obligatoire !")
};

tvrCVRFormMeta.velocityCheckCountersExceeded = {
  name: "velocityCheckCountersExceeded",
  type: "checkbox",
  label: "Compteurs Vérification Vélocité Dépassé",
  placeholder: "",
  validation: yup.boolean().required("Champ obligatoire !")
};

tvrCVRFormMeta.offlinePinVerificationFailure = {
  name: "offlinePinVerificationFailure",
  type: "checkbox",
  label: "Echec Vérification Pin Offline",
  placeholder: "",
  validation: yup.boolean().required("Champ obligatoire !")
};

tvrCVRFormMeta.newCard2 = {
  ...tvrCVRFormMeta.newCard,
  name: "newCard2",
};

tvrCVRFormMeta.trialPinLimitAndApplicationBlocked = {
  name: "trialPinLimitAndApplicationBlocked",
  type: "checkbox",
  label: "Limite Essai Pin Dépassée et Application Bloquée",
  placeholder: "",
  validation: yup.boolean().required("Champ obligatoire !")
};

tvrCVRFormMeta.secondCryptogramType = {
  name: "secondCryptogramType",
  type: "text",
  label: "Deuxième Type Cryptogram",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
};

tvrCVRFormMeta.firstCryptogramType = {
  name: "firstCryptogramType",
  type: "text",
  label: "Premier Type Cryptogram",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
};

tvrCVRFormMeta.trialPinLimitExceededAndApplicationBlocked = {
  name: "trialPinLimitExceededAndApplicationBlocked",
  type: "text",
  label: "Limite Essai Pin Dépassée et Application Bloquée",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
};


tvrCVRFormMeta.schema = yup.object().shape(getValidationSchema(tvrCVRFormMeta));

export default tvrCVRFormMeta;